/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import { useGlobalAudio } from '@/context/global-audio-context/use-global-audio.ts';
import { MicIcon } from 'lucide-react';

/**
 * Must be wrapped with GlobalAudioProvider to use correct deviceId
 * @constructor
 */
export const MicIndicator = () => {
  const { isSpeaking, volumeLevel } = useGlobalAudio();

  return (
    <div className="flex flex-row items-center justify-center select-none">
      <div className="relative -rotate-90 h-1 w-6 rounded-full bg-muted overflow-hidden">
        <div
          className={`absolute inset-y-0 left-0 rounded-full bg-green-400`}
          style={{ width: `${Math.max(volumeLevel * 100, 0)}%` }}
        />
      </div>

    </div>
  );
};
